module.exports = __webpack_public_path__ + "img/dauphine.9a7ed6ce.png";